import { style } from 'typestyle'
export const pb0 = style({ paddingBottom: '0px' })
